import { computed } from 'mobx';
import { IEntity, IEntityStore } from '../../main/entities';
import { MgHasher } from '../../mg/MgHasher';
import { DelegateRepo } from './DelegateRepo';

export class FilterRepo<E extends IEntity> extends DelegateRepo<E> implements IEntityStore<E> {
	private readonly filters: false | Array<(e: E) => boolean>;

	constructor(delegate: IEntityStore<E>, ...filters: Array<boolean | ((e: E) => boolean)>) {
		super(delegate);
		const x = filters.filter(f => typeof f === 'function');
		this.filters = filters.includes(false) ? false : filters.filter(f => typeof f === 'function') as any;
	}

	private filter(e: E) : boolean {
		if (this.filters===false) return false;
		for (const f of this.filters) {
			if (!f(e)) return false;
		}
		return true;
	}

	@computed get length() {
		return this.allAsList.length;
	}

	@computed get allAsList() {
		return this.delegate.allAsList.filter(e => this.filter(e));
	}

	@computed get etag() {
		if (!this.filters) return new MgHasher().addString(this.id).addString('-empty-').toString();
		if (!this.delegate.etag) return '';
		return new MgHasher().addString(this.id).addString(this.delegate.etag).addUnordered(this.allAsList.map(e => e.id)).toString();
	}

	readonly byId = (id: string | number | undefined) : E | undefined => {
		const r = this.delegate.byId(id);
		return r && this.filter(r) ? r : undefined;
	}
}
